import { IconButton } from "@walmart-web/livingdesign-components"
import { Eye, EyeSlash } from "@walmart-web/livingdesign-icons"
import React from "react"

interface TrailingShowPasswordProps {
	a11yLabel: string
	actionClick: () => void
	isVisible: boolean
	isDisabled?: boolean
}

const TrailingShowPassword: React.FC<TrailingShowPasswordProps> = ({
	a11yLabel,
	actionClick,
	isVisible,
	isDisabled = false,
}) => {
	return (
		<IconButton
			a11yLabel={a11yLabel}
			key="IconButton"
			size="medium"
			onClick={actionClick}
			disabled={isDisabled}
		>
			{isVisible ? (
				<Eye data-testid="show-password" />
			) : (
				<EyeSlash data-testid="hide-password" />
			)}
		</IconButton>
	)
}

export default TrailingShowPassword
